/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useMemo } from 'react';
import { Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { openDialog } from '@/features/dialog/dialogSlice';
import { useObjectContext } from '@/hooks/useObjectContext';
import { usePipelineContext } from '@/context/pipelineContext';
import { useFeatureFlagContext } from '@/context/featureFlagContext';

export const AddPolicyButton = () => {
	const dispatch = useDispatch();
	const { dealRow } = useObjectContext();

	const dealStage = dealRow?.dealStage;

	const { checkEndorsementStage, closed, completed } = usePipelineContext(dealRow?.pipeline);

	const isEndorsementStage = checkEndorsementStage(dealRow?.dealStage);

	const { getFeatureFlags } = useFeatureFlagContext();
	const showButton = Boolean(getFeatureFlags('addPolicy')?.active);

	const isRenewal = dealRow?.pipeline === process.env.REACT_APP_PIPELINE_RENEWALS;
	const isEndorsement = dealRow?.pipeline == process.env.REACT_APP_PIPELINE_ENDORSEMENTS;

	const handleOpenDialog = () => {
		dispatch(
			openDialog({
				dialogName: 'editPolicyTransaction',
				data: { policy: null, type: 'policy' },
			}),
		);
	};
	const shouldShowButton = useMemo(() => {
		if ((isRenewal || isEndorsement || isEndorsementStage) && showButton) return true;
		return (closed.includes(dealStage) || completed.includes(dealStage)) && showButton;
	}, [isRenewal, isEndorsement, dealStage, showButton, isEndorsementStage, closed, completed]);

	return (
		shouldShowButton && (
			<Button variant='tab_header' startIcon={<Add />} onClick={handleOpenDialog}>
				{'Add policy'}
			</Button>
		)
	);
};
